export default __webpack_public_path__ + "static/media/1.c1315024.jpg";